export default function ThreeDotsLoader({size}) {
    return (
        <img src="/assets/3-dots-loader.svg" className={`w-${size} pointer-events-none`} alt=""/>
    )
}
